import React from 'react';
import { CMXIcon, MedicalCodeChip } from '@codametrix/ui-components';
import ScoringCategoryBadge from './ScoringCategoryBadge';
import { s } from './finalCodeset.styles';
import { chipTypeMap } from './finalCodeset.utils';
import { BreakdownEntry } from './useScoringEvents';

type CodesetRowProps = {
  code: CQA.ResolverCodeDto;
  isDragOver: boolean;
  canViewScore: boolean;
  hasLiveScore: boolean;
  entry: BreakdownEntry | undefined;
  onDragStart: () => void;
  onDragOver: (e: React.DragEvent) => void;
  onDragLeave: () => void;
  onDrop: (e: React.DragEvent) => void;
  onDragEnd: () => void;
};

export function CodesetRow({
  code,
  isDragOver,
  canViewScore,
  hasLiveScore,
  entry,
  onDragStart,
  onDragOver,
  onDragLeave,
  onDrop,
  onDragEnd
}: CodesetRowProps) {
  return (
    <div
      style={isDragOver ? { ...s.row, ...s.rowDragOver } : s.row}
      draggable
      onDragStart={onDragStart}
      onDragOver={onDragOver}
      onDragLeave={onDragLeave}
      onDrop={onDrop}
      onDragEnd={onDragEnd}>
      <span style={s.grabber}>
        <CMXIcon svgIconName="BiomeGripperSVG20" svgIconSize="20" svgIconClass="gripper" />
      </span>
      <span style={s.chip}>
        <MedicalCodeChip
          code={code.code}
          codeType={chipTypeMap[code.codeType] ?? 'procedure'}
          editable={false}
        />
      </span>
      {canViewScore && hasLiveScore && (
        <span style={s.scoreCell}>
          <ScoringCategoryBadge
            value={entry ? entry.category : '0_IDEAL'}
            score={entry ? entry.rubricPoints : null}
          />
        </span>
      )}
    </div>
  );
}
